/*global Show*/

import {state} from './AppState';
import ClientInfo from './User';
import './main'
import './showPage';


(function() {

    state.user = new ClientInfo();

})();

/*import TicketSelector from './Components/TicketSelector';
import React from 'react';
import ReactDOM from 'react-dom';

ReactDOM.render(
    <TicketSelector events={Show.events} settings={Show.tickets_app} />,
    document.getElementById('ticket-selector')
);*/


